<template>
  <div>
    <b-container fluid class="p-0 root-container">
      <component :is="layout">
        <router-view />
      </component>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState('common', ['dark']),
    layout() {
      return this.$route.meta.layout || 'div'
    }
  }
}
</script>
